import React from "react";
import store from "./../redux/index";

const useConfigStaking = () => {
  return store.getState().stake.config;
};

export default useConfigStaking;
